import React from 'react';
import { Link } from 'react-router-dom';
export function Terms() {
  return <div className="max-w-3xl mx-auto px-6 pt-32 pb-24" data-id="element-13056" data-mp="3tp0mg01wleqe">
      <h1 className="text-4xl font-bold text-[#2B211A] mb-8 font-title tracking-tight" data-id="element-13057" data-mp="3tpk4dgrk034f">
        Terms of Service
      </h1>

      <div className="space-y-10 text-neutral-700 font-body leading-relaxed text-[17px]" data-id="element-13058" data-mp="2gmulhnx2gta">
        <section data-id="element-13059" data-mp="7biwd9iygijl">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-13060" data-mp="c8j2tljpvnb8">
            1. Acceptance of Terms
          </h2>
          <p data-id="element-13061" data-mp="g9314sg10wyy">
            By accessing or using Giga ("Service"), you agree to be bound by
            these Terms of Service. If you disagree with any part of the terms,
            you may not access the Service. These terms apply to all visitors,
            users, and others who access or use the Service.
          </p>
        </section>

        <section data-id="element-13062" data-mp="2n2wzt7dptlry">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-13063" data-mp="2rzf1tzhnv60l">
            2. Account Terms
          </h2>
          <ul className="list-disc pl-5 space-y-2" data-id="element-13064" data-mp="23a4qlbwgwfka">
            <li data-id="element-13065" data-mp="1yimp8mqj8cys">You must be 18 years or older to use this Service.</li>
            <li data-id="element-13066" data-mp="1yhbhycxvon2x">
              You must provide your legal full name, a valid email address, and
              any other information requested in order to complete the signup
              process.
            </li>
            <li data-id="element-13067" data-mp="1pg52m76ytib9">
              You are responsible for maintaining the security of your account
              and password. Giga cannot and will not be liable for any loss or
              damage from your failure to comply with this security obligation.
            </li>
            <li data-id="element-13068" data-mp="2d5zd4i3tausc">
              You are responsible for all content posted and activity that
              occurs under your account.
            </li>
          </ul>
        </section>

        <section data-id="element-13069" data-mp="11t59tg1qzcjw">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-13070" data-mp="11tosx034w6zi">
            3. API Usage
          </h2>
          <p className="mb-4" data-id="element-13071" data-mp="yag6xgzpfttn">
            Customers may access their Giga account data via an API (Application
            Program Interface). Any use of the API, including use of the API
            through a third-party product that accesses Giga, is bound by these
            Terms of Service plus the following specific terms:
          </p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-13072" data-mp="ta1xpvmdadu1">
            <li data-id="element-13073" data-mp="fjyg5hyfn8ax">
              You expressly understand and agree that Giga shall not be liable
              for any direct, indirect, incidental, special, consequential or
              exemplary damages, including but not limited to, damages for loss
              of profits, goodwill, use, data or other intangible losses
              resulting from your use of the API.
            </li>
            <li data-id="element-13074" data-mp="3sqi2tc90kqnq">
              Abuse or excessively frequent requests to Giga via the API may
              result in the temporary or permanent suspension of your account's
              access to the API.
            </li>
          </ul>
        </section>

        <section data-id="element-13075" data-mp="3e4bbn5ep8i5m">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-13076" data-mp="3e5vu3wnqoan4">
            4. Data and Privacy
          </h2>
          <p data-id="element-13077" data-mp="3n4zfj7adp24s">
            Your use of the Service is also governed by our Privacy Policy. Giga
            claims no intellectual property rights over the material you provide
            to the Service. Your profile and materials uploaded remain yours.
          </p>
        </section>

        <section data-id="element-13078" data-mp="3s3u6iwii1wzz">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-13079" data-mp="3s4cdan2sftm5">
            4.5 User Data Deletion
          </h2>
          <p data-id="element-13080" data-mp="am9pdr8hj4vx">
            You may delete your account at any time. Upon deletion, we will
            remove or anonymise your data within 30 days. You may also request
            deletion of specific integration data by contacting us at{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-13081" data-mp="ep68rk5un50x">
              support@getgiga.com
            </a>
            . We comply with data deletion requests as required by applicable
            law and the Google API Services User Data Policy.
          </p>
        </section>

        {/*
         * SMS & TEXT MESSAGING.
         *
         * Required for US A2P 10DLC messaging registration: a reviewer opens
         * this page and checks that the public terms describe the texting
         * being registered — consent, STOP to opt out, HELP for help, that
         * frequency varies and rates may apply, and that the named legal
         * entity matches the registration. The consent checkboxes on the
         * enquiry form already carry this language; a mismatch between the
         * form and these pages is a common rejection reason, so the two must
         * be changed together.
         *
         * Placed beside Data and Privacy rather than at the end: it is a
         * communications and data topic, and it needs to be findable.
         */}
        <section data-id="element-13082" data-mp="3pnu41u9lga6h">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-13083" data-mp="3podn5eazd4m3">
            4.6 SMS &amp; Text Messaging
          </h2>
          {/*
           * THE FIRST PARAGRAPH IS THE CARRIER-REVIEWED WORDING, VERBATIM.
           * Do not paraphrase, split or "tighten" it — a reviewer diffs this
           * against the copy submitted with the campaign registration.
           */}
          <p className="mb-4" data-id="element-13084" data-mp="36zyu6lh3rgin">
            By providing your phone number and opting in, you consent to receive
            automated and/or recurring text (SMS) messages from Giga (operated
            by Tonic Labs Limited) about your enquiry or demo, such as
            confirmations, reminders and follow-ups, and — if you separately opt
            in — promotional messages. Consent to promotional messages is not a
            condition of using our service. Message frequency varies; message
            and data rates may apply. Reply{' '}
            <strong className="text-[#2B211A]" data-id="element-13085" data-mp="2kpgqi5tr18a4">STOP</strong> to opt out,{' '}
            <strong className="text-[#2B211A]" data-id="element-13086" data-mp="2ko5q8fziiinr">HELP</strong> for help. We do not
            sell your phone number; see our{' '}
            <Link to="/privacy" className="text-[#EA580C] hover:underline font-medium" data-id="element-13087" data-mp="2bptww679h6rm">
              Privacy Policy
            </Link>
            .
          </p>
          {/* Detail beyond the registered wording, not a restatement of it. */}
          <ul className="list-disc pl-5 space-y-2" data-id="element-13088" data-mp="33h9ipy0zupgs">
            <li data-id="element-13089" data-mp="38g2xruvxioj2">
              Messages are sent to the number you provide, and your mobile
              carrier may charge you for messages you receive.
            </li>
            <li data-id="element-13090" data-mp="2zev11h929vr3">
              We honour opt-out requests promptly. Opting out of promotional
              messages does not affect service-related messages we are permitted
              to send you.
            </li>
          </ul>
        </section>

        <section data-id="element-13091" data-mp="1o0hhupp964he">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-13092" data-mp="1o10ze5azqquw">
            5. Termination
          </h2>
          <p data-id="element-13093" data-mp="1bhdshnyif0m2">
            We may terminate or suspend access to our Service immediately,
            without prior notice or liability, for any reason whatsoever,
            including without limitation if you breach the Terms. All provisions
            of the Terms which by their nature should survive termination shall
            survive termination, including, without limitation, ownership
            provisions, warranty disclaimers, indemnity and limitations of
            liability.
          </p>
        </section>

        <section data-id="element-13094" data-mp="16j2j1ec4ms4d">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-13095" data-mp="16jlpnywbtu33">
            5.5 Acceptable Use
          </h2>
          <p data-id="element-13096" data-mp="e1q6ec1it90q">
            You agree not to use the Service for any unlawful purpose or in
            violation of any applicable laws or regulations. You may not use
            the Service to transmit malware, spam, or content that infringes
            third-party rights. We reserve the right to suspend or terminate
            accounts engaged in prohibited use.
          </p>
        </section>

        <section data-id="element-13097" data-mp="3tmvtyv9i5285">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-13098" data-mp="3tmck81u09k57">
            6. Limitation of Liability
          </h2>
          <p data-id="element-13099" data-mp="2hw1rdcsnzes">
            In no event shall Giga, nor its directors, employees, partners,
            agents, suppliers, or affiliates, be liable for any indirect,
            incidental, special, consequential or punitive damages, including
            without limitation, loss of profits, data, use, goodwill, or other
            intangible losses, resulting from your access to or use of or
            inability to access or use the Service.
          </p>
        </section>

        <section data-id="element-13100" data-mp="q7girqpe0mlf">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-13101" data-mp="q803ff6f9p35">
            7. Governing Law
          </h2>
          <p data-id="element-13102" data-mp="2epjiai6ipn31">
            These Terms shall be governed by and construed in accordance with
            the laws of Ireland. Any disputes arising under these Terms shall
            be subject to the exclusive jurisdiction of the courts of Ireland.
          </p>
        </section>

        <section data-id="element-13103" data-mp="25qxy6ilee005">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-13104" data-mp="20qa23iibasz2">
            8. Service Availability
          </h2>
          <p data-id="element-13105" data-mp="2yd91w24awh16">
            We strive for high availability but do not guarantee uninterrupted
            access. We reserve the right to perform maintenance, updates, or
            suspend access as needed with reasonable notice where practicable.
          </p>
        </section>

        <section data-id="element-13106" data-mp="2jnumode1n5dv">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-13107" data-mp="2jocrvziootxx">
            9. Third-Party Services
          </h2>
          <p data-id="element-13108" data-mp="3cdticrmqu0ri">
            Giga connects to third-party services you authorise via OAuth. We
            are not responsible for the availability, security, or data
            practices of those services. Your use of connected third-party
            services remains subject to their terms and privacy policies.
          </p>
        </section>

        {/*
         * WHO THESE TERMS ARE WITH. The page governed by Irish law but never
         * named the entity, so a messaging or payments reviewer could not match
         * it against the registration. The registered address is deliberately
         * NOT invented here — add the real one from the CRO filing.
         */}
        <section data-id="element-13109" data-mp="2ksp8fsu5l3ni">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-13110" data-mp="2zj69hb2vlrjv">
            10. Operator and Contact
          </h2>
          <p data-id="element-13111" data-mp="2ukuz8z8o5f14">
            Giga is operated by{' '}
            <strong className="text-[#2B211A]" data-id="element-13112" data-mp="38juni5s9rrwr">Tonic Labs Limited</strong>, a
            company registered in Ireland. Questions about these Terms, or
            about messages you receive from us, can be sent to{' '}
            <a href="mailto:support@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-13113" data-mp="3n6kxrwnz0uuh">
              support@getgiga.com
            </a>
            .
          </p>
        </section>

        <section className="pt-8 border-t border-neutral-200/60" data-id="element-13114" data-mp="3e6y0nn29yb78">
          <p className="text-sm text-neutral-500" data-id="element-13115" data-mp="3j57spospcvom">Last updated: September 2026</p>
        </section>
      </div>
    </div>;
}